import { lazy } from "react";

const ViewProfile = lazy(() => import("../../../pages/User/Profile/Profile"));
const UpdateProfile = lazy(() =>
  import("../../../pages/User/Profile/UpdateProfile")
);
import { viewProfileLoader, updateProfileLoader } from "./profileLoaders";
export const profileRoutes = [
  {
    path: "profile",
    element: <ViewProfile />,
    loader: viewProfileLoader,
  },
  {
    path: "profile/:id/update",
    element: <UpdateProfile />,
    loader: updateProfileLoader,
  },
];
